import { Capacitor } from '@capacitor/core'
import { Haptics, ImpactStyle } from '@capacitor/haptics'

/** 
 * Use this for a typed platform. The function provided by Capacitor, `getPlatform()`,
 * just returns a string but the values will only ever be `ios`, `android`, and 'web'
 */
export const platform = Capacitor.getPlatform() as 'ios' | 'android' | 'web'

/** 
 * Triggers a haptics "impact" medium feedback
 */
export async function hapticsImpactMedium() {
    try {
        await Haptics.impact({ style: ImpactStyle.Medium })
    } catch (error) {
        console.warn('Haptics not available:', error)
    }
}